import React from 'react';

import * as Types from '../types';
import * as helpers from '../helpers';

export const withFieldProps =
<FieldValue, P extends object>(Wrapped: React.ComponentType<P>) =>
    (props: P & Types.TFinalFormFieldProps<FieldValue>) => {
    const { displayValuesMap, maxValue } = props;

    return (
        <Wrapped
            parse={(value: string) => helpers.parse({ value, displayValuesMap, maxValue })}
            format={(value: string) => helpers.format({ value, displayValuesMap })}
            {...props}
        />
    );
};
